export const SourceAirport = "airports";

export const TitleAirport = {
  list: "Airport List",
  edit: "Edit Airport",
  create: "Create Airport",
};
